/**
 * Nombre y lema de Rol Sensorial, en un solo lugar.
 *
 * Igual que `site.name` y `site.description` en el `_config.yml` de Jekyll:
 * cambiar el lema acá lo cambia en el título de la pestaña, la portada y el
 * pie de página a la vez, en vez de tener que buscarlo en cada archivo.
 */
export const SITE_NAME = 'Rol Sensorial';

/** En minúscula y con punto final, como en Jekyll: se usa tal cual después de un guion. */
export const SITE_TAGLINE = 'juega con tus sentidos, imagina sin límites.';

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** Lema con mayúscula inicial, para cuando abre una oración (portada, pie de página). */
export const SITE_TAGLINE_CAPITALIZED = capitalize(SITE_TAGLINE);

/**
 * Título de pestaña. Sin `pageTitle`, es el de la portada:
 * "Rol Sensorial – juega con tus sentidos, imagina sin límites."
 */
export function siteTitle(pageTitle?: string): string {
  if (pageTitle) return `${pageTitle} - ${SITE_NAME}`;
  return `${SITE_NAME} - ${SITE_TAGLINE}`;
}
